import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';
import Cookies from 'js-cookie';
import * as constants from 'constants/index.js';
import axios from 'axios';

import InputCustom from 'views/pages/components/InputCustom';
import TableCustom from 'views/pages/components/TableCustom';

import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    Row,
    UncontrolledDropdown,
} from "reactstrap";

import {create, update,} from 'views/policies/PermissionPolicy';

import CardsHeader from 'layouts/Headers/CardsHeader.js';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import notify from "@utils/notify";

export default function Permission() {
  const history = useHistory();

  const roles = useSelector(state => state.getState).roles;

  const [token, setToken] = useState('');
  const [permissions, setPermissions] = useState([]);

  const [addModal, setAddModal] = useState(false);
  const [permission, setPermission] = useState({
    name: '',
    display_name: '',
    description: ''
  });
  
  const [loading, setLoading] = useState(true);

  const [errors, setErrors] = useState('');


  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/permission`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setPermissions(data.data)

        setTimeout(() => {
          setLoading(false)
        }, 500);
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const addPermission = () => {
    axios({
      method: 'POST',
      url: constants.API_URL + '/permission',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: permission
    })
      .then(response => {
        setLoading(false);
        if (response.status === 200) {
          let data = response.data;
          notify.success(data.message);
          setTimeout(() => {
            history.push({
              pathname: '/admin/permission/' + data.data.id + '/edit',
              state: {
                permission: data.data
              }
            });
          }, 1500);
        }
      })
      .catch(error => {
        setErrors('');
        setLoading(false);
        console.error('error :: ', error);
        if (error.response.status === 422) {
          let errors = error.response.data.errors;
          setErrors(errors);
          return
        }
        notify.error(error.response.statusText);
      })
  }

  const editPermission = (row) => {
    history.push({
      pathname: '/admin/permission/' + row.id + '/edit',
      state: {
        permission: row
      }
    });
  }

  return (
    <>
      <CardsHeader name="Admin" parentName="Permission Management" currentName="List" />

      <Container className="mt--6 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Permissions</h1>
                    <p className="text-sm mb-0">Permission management. List of permission.</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    {create(roles) &&
                      <ButtonContainer reverse onClick={() => setAddModal(true)}>Add permission</ButtonContainer>}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  keyField={`name`}
                  searchField={true}
                  items={permissions}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      sort: true
                    },

                    {
                      dataField: "action",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {update(roles, row) && 
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                color=""
                                role="button"
                                size="sm"
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem
                                  onClick={() => editPermission(row)}
                                >
                                  Edit
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>}
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={addModal}
          toggle={() => setAddModal(false)}
          className="modal-dialog-centered modal-secondary"
        >
          <div className="modal-header">
            <h2 className="title">Permission Information</h2>
          </div>
          <div className="modal-body">
            <form className="new-event--form">
              <InputCustom 
                label={`Name`}
                placeholder={`Name`}
                onChange={(e) => setPermission({
                  ...permission,
                  name: e.target.value
                })}
                invalid={errors && errors.name? true: false}
                errorMessage={errors.name}
              />
              <InputCustom 
                label={`Display name`}
                placeholder={`Display name`}
                onChange={(e) => setPermission({
                  ...permission,
                  display_name: e.target.value
                })}
                invalid={errors && errors.display_name? true: false}
                errorMessage={errors.display_name}
              />
              <InputCustom 
                type={`textarea`}
                rows={8}
                label={`Description`}
                placeholder={`Description`}
                onChange={(e) => setPermission({
                  ...permission,
                  description: e.target.value
                })}
                invalid={errors && errors.description? true: false}
                errorMessage={errors.description}
              />
            </form>
          </div>
          <div className="modal-footer">
            <ButtonContainer
             reverse
              onClick={() => addPermission()}
            >
              Save
            </ButtonContainer>
            <ButtonContainer
              onClick={() => setAddModal(false)}
            >
              Cancel
            </ButtonContainer>
          </div>
        </Modal>
      </Container>
    </>
  )
}